<template>
	<!-- TODO: WHOOHOOOOO INLINESTYLE FOR THE WORLD -->
	<div class="selfordering-login">
		<template
			v-if="!isLoggedIn"
		>
			<FormLogin
				ref="loginForm"
				@loggedIn="onLoggedIn"
			/>
			<FormRegister
				ref="registerForm"
				phone
			/>
		</template>
		<template v-else-if="showPhoneForm">
			<h2 v-html="$t('account.selfordering.addPhoneTitle')"/>
			<p v-html="$t('account.selfordering.addPhoneText')"/>
			<ValidationObserver
				ref="phoneForm"
				v-slot="{ invalid, errors }"
				class=""
				tag="form"
				@submit.prevent="onPhoneUpdate"
				novalidate
			>
				<GeneralMessage
					v-if="phoneResponse.message"
					:message="phoneResponse.message"
					:type="phoneResponse.type"
					@close="phoneResponse.message = ''"
				/>
				<ValidationProvider
					class="input-wrapper"
					name="phone"
					rules="required|phone_int"
					v-slot="{ errors, invalid, validated }"
					tag="div"
					:customMessages="{ required: $t('forms.errors.fieldEmpty'), phone_int: $t('forms.errors.phone') }"
				>
					<FormInput
						type="tel"
						:placeholder="$t('forms.labels.phone')"
						:label="$t('forms.labels.phone')"
						name="phone"
						v-model="phoneForm.phoneNumber"
						:error="errors.length > 0"
						:error-message="errors[0]"
						:hint="$t('login.phoneHint')"
						required
					/>
				</ValidationProvider>

				<Button
					type="submit"
					level="primary"
					:text="$t('account.safeButton')"
				/>
			</ValidationObserver>
		</template>
		<div class="selfordering-login__details" v-else>
			<h2 v-html="$t('account.selfordering.qrcodeTitle')" />
			<p v-html="$t('account.selfordering.qrcodeText')" />

			<div class="selfordering-login__user">
				<div class="selfordering-login__user-name" v-html="`${accountUserDetail.firstName} ${accountUserDetail.lastName}`"/>
				<div class="selfordering-login__user-email" v-html="accountUserDetail.email"/>
				<div class="selfordering-login__user-phone" v-html="accountUserDetail.phoneNumber"/>
				<Button
					v-if="this.accountUserDetail.phoneNumber"
					@click.prevent="onPhoneChange"
					level="tertiary"
					type="button"
					:text="$t('account.selfordering.changePhoneButton')"
					arrow
				/>
			</div>

			<QRCode
				:content="accountQrTokenPrefixed"
			/>
			<SVGScanIllustrationPhone/>
		</div>
	</div>
</template>

<script>
import Vue from "vue"
import { mapGetters } from "vuex"
import GenericMixin from '@/mixins/GenericVueMixin';
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormLogin from '@/components/FormLogin';
import FormRegister from '@/components/FormRegister';
import FormInput from '@/components/FormInput';
import GeneralMessage from '@/components/GeneralMessage'
import Button from '@/components/Button';
import QRCode from '@/components/QRCode';
import htmlComponent from 'htmlcomponent'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormLogin,
		FormRegister,
		FormInput,
		GeneralMessage,
		Button,
		QRCode,
	},
	props: {
		overlayType: {
			type: String,
			default() {
				return 'login';
			},
		},
		requirePhone: Boolean,
	},
	data() {
		return {
			phoneForm: {
				phoneNumber: '',
			},
			phoneResponse: {
				type: 'info',
				message: '',
			},
			showPhoneForm: false,
			phoneRequired: this.requirePhone || this.$root.options.phoneRequired,
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
			"accountQrToken",
			"accountQrTokenPrefixed",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
	},
	watch: {
		isLoggedIn: function(value, oldValue) {
			if (value && value != oldValue) {
				this.onLoggedIn();
			}
		}
	},
	methods: {
		resetForm() {
			this.$refs.loginForm.resetForm();
			this.$refs.registerForm.resetForm();
		},
		async onLoggedIn() {
			this.loading = true;
			this.phoneForm.phoneNumber = this.accountUserDetail.phoneNumber || '';
			this.showPhoneForm = !this.accountUserDetail.phoneNumber && this.phoneRequired;
			await this.$store.dispatch('account/loadQRToken');
			this.loading = false;
		},
		onPhoneChange() {
			this.phoneForm.phoneNumber = this.accountUserDetail.phoneNumber || '';
			this.showPhoneForm = true;
		},
		async onPhoneUpdate() {
			const isValid = await this.$refs.phoneForm.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
				try {
					await this.$store.dispatch('account/updateUser', {
						userDetail: {
							...this.accountUserDetail,
							...this.phoneForm,
						}
					})
					this.$refs.phoneForm.reset();
					this.phoneForm.phoneNumber = '';
					this.phoneResponse.message = '';
					this.phoneResponse.type = 'info';
					this.showPhoneForm = false;
				} catch(err) {
					let message = err && err.response && err.response.data ? err.response.data.message : this.$t('forms.errors.generic')
					this.phoneResponse.message = message;
					this.phoneResponse.type = 'error';
				}
				this.loading = false;
			}
		},
	},
	created() {
		this.loading = true;
	},
	mounted() {
		this.loading = true;
		if (this.isLoggedIn) {
			this.onLoggedIn();
		}
		this.loading = false;
	}
}
</script>

<style>

</style>
